<template>
    <div id="div_spConfig">
        <div id="div_labelList_options">
            <table id="table_labelList"
                class="labelOptions"
                width="100%">
                <tr>
                    <td colspan="2" style="padding-bottom: 3px;">
                        <span 
                            style="font-size: var(--text-md); font-weight: bold"
                            :style="{ color : GET_colorTheme.titles }"
                        >
                            Opções
                        </span>
                    </td>
                </tr>

                <tr>
                    <td class="imgList_body_text" colspan="2">
                        Paths fechadas: 
                        <input v-model="vModels.closedPaths"
                            type="checkbox" 
                            style="float: right;"
                            @change="closedPathsChange"
                        >
                    </td>
                </tr>

                <tr>
                    <td class="imgList_body_text" colspan="2">
                        Pular q/ marcar: 
                        <input v-model="vModels.labelJump"
                            type="checkbox" 
                            style="float: right;"
                            @change="labelJumpChange"
                        >
                    </td>
                </tr>

                <tr>
                    <td class="imgList_body_text" colspan="2">
                        <span>Nav. (dt)</span>
                        <select 
                            v-model="vModels.selToothNav" 
                            style="float: right; width:90px"
                            @change="toothNavChange"
                        >
                            <option value=0>Dinâmica</option>
                            <option value=1>Fixa</option>
                        </select>
                    </td>
                </tr>

                <tr>
                    <td class="imgList_body_text" colspan="2">
                        Center (dt): 
                        <input v-model="vModels.centerTooth"
                            type="checkbox"
                            style="float: right;"
                            @change="centerToothChange"
                            :disabled="vModels.selToothNav == gConsts.dente.navTypes.DYNAMIC"
                        >
                    </td>
                </tr>



                <tr>
                    <td class="imgList_body_text" colspan="2">
                        Label Opac.: 
                        <input v-model="vModels.labelOpac"
                            type="range" min="0" max="100" value="100" class="slider"
                            style="float: right; width:80px"
                            @change="labelOpacChange"
                        >
                    </td>
                </tr>

                <tr>
                    <td class="imgList_body_text" colspan="2">
                        Tool Opac.: 
                        <input v-model="vModels.toolOpac"
                            type="range" min="0" max="100" value="100" class="slider"
                            style="float: right; width:80px"
                            @change="toolOpacChange"
                        >
                    </td>
                </tr>

                <tr>
                    <td class="imgList_body_text" colspan="2">
                        Margem (dt): 
                        <input v-model="vModels.dentesROIFactor"
                            type="range" min="5" max="15" value="10" class="slider"
                            style="float: right; width:80px"
                            @change="dentesROIFactorChange"
                        >
                    </td>
                </tr>

                <tr>
                    <td class="imgList_body_text" colspan="2">
                        Anom Opac.: 
                        <input v-model="vModels.anomHeatMapOpac"
                            type="range" min="0" max="100" value="0" class="slider"
                            style="float: right; width:80px"
                            @input="anomHeatMapOpacChange"
                        >
                    </td>
                </tr>

            </table>

        </div>
    </div>
</template>

// =========================================================================================
// =========================================================================================

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import { gConsts } from '@/globals/gConsts';
import { undoRedoHistory } from '@/globals/undoRedo';


// =========================================================================================

export default {
    name : 'configCMP',
    props: {
    }, 

    // -----------------------------------------------------------------

    data () {
        return {
            gConsts : gConsts,
            vModels : {
                closedPaths : false,
                labelJump   : false,
                selToothNav : gConsts.dente.navTypes.DYNAMIC,
                centerTooth : false,
                labelOpac   : 100,
                toolOpac    : 100,
                dentesROIFactor : 10,
                anomHeatMapOpac : 0,
            }
        }
    },

    // -----------------------------------------------------------------

    computed: {  
        ...mapState([
        ]),

        // -----------------------------------------------------------------

        ...mapGetters([
            'GET_colorTheme'
        ]),
    },

    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
                'ACT_setupUpdate'
        ]),

        // -----------------------------------------------------------------

        closedPathsChange(evt) {
            this.ACT_setupUpdate({ config : { closedPaths : evt.target.checked } });
        },

        // -----------------------------------------------------------------

        labelJumpChange(evt) {
            this.ACT_setupUpdate({ config : { labelJump : evt.target.checked } });
        },

        // -----------------------------------------------------------------

        toothNavChange(evt) {
            this.ACT_setupUpdate({ config : { toothNav : evt.target.value } });
        },

        // -----------------------------------------------------------------

        centerToothChange(evt) {
            this.ACT_setupUpdate({ config : { centerTooth : evt.target.checked } });
        },

        // -----------------------------------------------------------------

        labelOpacChange(evt) {
            this.ACT_setupUpdate({ config : { labelOpac : evt.target.value } });
        },

        // -----------------------------------------------------------------

        toolOpacChange(evt) {
            this.ACT_setupUpdate({ config : { toolOpac : evt.target.value } });
        },

        // -----------------------------------------------------------------

        dentesROIFactorChange(evt) {
            this.ACT_setupUpdate({ config : { dentesROIFactor : evt.target.value } });
        },

        // -----------------------------------------------------------------

        anomHeatMapOpacChange(evt) {
            this.ACT_setupUpdate({ config : { anomHeatMapOpac : evt.target.value } });
        },

        // -----------------------------------------------------------------

        mounted() {            
            let config = this.$store.state.config;

            this.vModels.closedPaths     = config.closedPaths;
            this.vModels.labelJump       = config.labelJump;
            this.vModels.selToothNav     = config.selToothNav;
            this.vModels.centerTooth     = config.centerTooth;
            this.vModels.labelOpac       = config.labelOpac;
            this.vModels.toolOpac        = config.toolOpac;
            this.vModels.dentesROIFactor = config.dentesROIFactor;
            this.vModels.anomHeatMapOpac = config.anomHeatMapOpac;            
        }
    }
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>


#div_labelList_container {
    display: grid;
    overflow: auto;
    grid-template-columns : auto;
    grid-template-rows : auto 245px;
    grid-template-areas :
        "labelList_data"
        "labelList_options";
    row-gap: 5px;
    z-index: 1;
    box-shadow: -1px 0px 5px -2px #000000;
    position: relative;
    text-align: left;
}

#div_labelList_options {
    grid-area: labelList_options;
    box-shadow: 0px 2px 5px -2px #000000;
    z-index: 40;
}

#div_labelList_data {
    grid-area: labelList_data;
    box-shadow: 0px 1px 4px 0px rgba(150, 150, 150, 0.5);
    z-index: 40;
    position: relative;
    overflow: auto; 
}

table.labelOptions td {
    text-align: left;
}

</style>